export interface Actor {
  id: string;
  name: string;
  avatar: string;
  role: string;
  birthday: string;
  bio: string;
  works: string[];
}

export const actors: Actor[] = [
  {
    id: "a-01",
    name: "沈知遥",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20an%20elegant%20Chinese%20female%20actress%20in%20her%20thirties%20with%20calm%20expression%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-shen-01&orientation=squarish",
    role: "演员",
    birthday: "1990-04-18",
    bio: "毕业于中央戏剧学院的实力派女演员，以细腻克制的表演见长。早年活跃于话剧舞台，转战荧屏后凭借对复杂女性角色的精准把握赢得观众认可。",
    works: ["baise-chengbao", "changan-que", "zhuguang-zhe"],
  },
  {
    id: "a-02",
    name: "陆沉舟",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20serious%20Chinese%20male%20actor%20in%20his%20forties%20with%20short%20hair%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-lu-02&orientation=squarish",
    role: "演员 / 制片人",
    birthday: "1982-11-02",
    bio: "从影二十余年的戏骨级男演员，擅长塑造亦正亦邪的复杂人物。多次获得行业表演奖项提名，被观众称为“最稳的那块压舱石”。",
    works: ["miwu-zhuixiong", "dieying-chongchong", "chengshi-fusheng", "shiguang-youju"],
  },
  {
    id: "a-03",
    name: "江晚宁",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20confident%20Chinese%20female%20actress%20in%20her%20thirties%20with%20modern%20styling%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-jiang-03&orientation=squarish",
    role: "演员",
    birthday: "1992-07-26",
    bio: "都市题材的常客，气质干练又富有层次。她饰演的职场女性往往带着真实的疲惫与锋芒，被认为“演出了普通人上班的样子”。",
    works: ["chengshi-fusheng", "shanghai-chenfu", "yanhuo-renjian"],
  },
  {
    id: "a-04",
    name: "顾砚辞",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20refined%20Chinese%20male%20actor%20in%20his%20late%20thirties%20with%20sleek%20hair%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-gu-04&orientation=squarish",
    role: "演员",
    birthday: "1986-03-09",
    bio: "被称为“古装与正剧双栖”的男演员，台词功底扎实，气场沉稳。无论是朝堂权谋还是商海博弈，他都能演出分寸感。",
    works: ["changan-que", "shanhe-guren", "shanghai-chenfu"],
  },
  {
    id: "a-05",
    name: "苏拂雪",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20delicate%20Chinese%20female%20actress%20in%20her%20twenties%20with%20long%20dark%20hair%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-su-05&orientation=squarish",
    role: "演员",
    birthday: "1996-09-30",
    bio: "新生代人气女演员，古装扮相惊艳，表演灵气十足。从校园剧到奇幻爱情，她不断尝试不同类型的角色。",
    works: ["changan-que", "congcong-nanian", "shiguang-youju", "jianghu-yeyu"],
  },
  {
    id: "a-06",
    name: "韩陌",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20rugged%20Chinese%20male%20actor%20in%20his%20thirties%20with%20stubble%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-han-06&orientation=squarish",
    role: "演员",
    birthday: "1988-01-14",
    bio: "从龙套一步步走出来的草根演员，身上带着天然的烟火气。他擅长塑造小人物，一个眼神就能让人相信角色的来历。",
    works: ["xinghai-yuanzheng", "wuming-zhibei", "shenhai-huixiang", "chengshi-fusheng"],
  },
  {
    id: "a-07",
    name: "温亦然",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20warm%20smiling%20Chinese%20female%20actress%20in%20her%20forties%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-wen-07&orientation=squarish",
    role: "演员",
    birthday: "1979-06-05",
    bio: "家庭剧里的“国民妈妈”，笑声爽朗，表演自然。她总能把生活里最琐碎的细节演得让人热泪盈眶。",
    works: ["jiayou-xishi", "yanhuo-renjian", "miwu-zhuixiong"],
  },
  {
    id: "a-08",
    name: "秦子墨",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20an%20energetic%20young%20Chinese%20male%20actor%20in%20his%20twenties%20with%20clean%20styling%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-qin-08&orientation=squarish",
    role: "演员",
    birthday: "1998-02-22",
    bio: "偶像转型的青年演员，为了角色可以增重减重二十斤。近年在医疗、励志题材中的表现让人看到他的野心与努力。",
    works: ["baise-chengbao", "zhuguang-zhe", "miwu-zhuixiong", "congcong-nanian"],
  },
  {
    id: "a-09",
    name: "白若薇",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20mature%20elegant%20Chinese%20female%20actress%20in%20her%20fifties%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-bai-09&orientation=squarish",
    role: "演员",
    birthday: "1971-12-11",
    bio: "资深表演艺术家，长期活跃于影视与舞台之间。她塑造的母亲与长辈形象，总带着一种不动声色的力量。",
    works: ["shanhe-guren", "shenhai-huixiang", "wuming-zhibei", "jiayou-xishi"],
  },
  {
    id: "a-10",
    name: "谢临风",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20a%20sharp%20featured%20Chinese%20male%20actor%20in%20his%20thirties%20with%20intense%20gaze%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20warm%20gray%20background%2C%20consistent%20color%20grading%2C%20upper%20body%20composition%2C%20high%20detail&width=500&height=500&seq=actor-xie-10&orientation=squarish",
    role: "演员",
    birthday: "1989-08-08",
    bio: "以武打和动作戏见长的男演员，身手利落，镜头感极佳。他一直在尝试突破动作明星的标签，挑战更复杂的文戏。",
    works: ["xinghai-yuanzheng", "jianghu-yeyu", "dieying-chongchong"],
  },
];

export function getActorById(id: string): Actor | undefined {
  return actors.find((a) => a.id === id);
}

export function getActorsByIds(ids: string[]): Actor[] {
  return ids
    .map((id) => actors.find((a) => a.id === id))
    .filter((a): a is Actor => Boolean(a));
}